/**
 * Takes a base64url-encoded string (e.g. "nMueRPiAm51YXEjRtka8S_8Ura3HaqbmqDqMJCZmvkM")
 * and return the corresponding bytes, as an array buffer.
 */
export const base64UrlDecode = (s?: string) => {
  // Go from base64url encoding to base64 encoding
  s = s?.replace(/-/g, '+').replace(/_/g, '/') || '';
  // use `atob` to decode base64
  return Uint8Array.from(atob(s), (c) => c.charCodeAt(0));
};
